import { createSelector } from '@reduxjs/toolkit';
import { variantName } from './variants.js';
import { commonFieldsByCode } from 'src/store/fields';

export const fieldsByCode = createSelector(variantName, commonFieldsByCode);
